import { useMutation } from '@tanstack/react-query';
import { sendChatMessage } from '../api';

/**
 * Chat service hooks
 * React Query hooks for chat functionality
 */

export const useSendChatMessage = () => {
  return useMutation({
    mutationFn: ({ messages, userContext }) => sendChatMessage(messages, userContext),
    onSuccess: (data) => {
    },
    onError: (error) => {
      console.error('Error sending message:', error);
    }
  });
};
